export default "__VITE_ASSET__zj_YHb5f__"